import React from 'react';

interface AuthLoadingProps {
  message?: string;
}

/**
 * Loading component to show during authentication initialization
 */
export const AuthLoading: React.FC<AuthLoadingProps> = ({ 
  message = "Verificando autenticación..." 
}) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#F1F0FB] to-[#E5DEFF]">
      <div className="text-center">
        <div className="relative">
          {/* Main spinner */}
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
          
          {/* Secondary spinner */}
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-purple-400 mx-auto absolute top-2 left-2"></div>
        </div>
        
        <p className="mt-4 text-sm text-gray-600 font-medium">
          {message}
        </p>
        
        <div className="mt-2 flex justify-center space-x-1">
          <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-purple-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      </div>
    </div>
  );
}; 